<template>
  <div class="card" v-loading="loading">
    <div class="card-header d-flex justify-content-between">
      <div style="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr; gap: 20px">
        <el-input @change="filterOkrs" clearable placeholder="Tìm kiếm theo tên" v-model="filters.name" />
        <el-select v-model="filters.quarter" clearable @change="filterOkrs" placeholder="Chọn quý">
          <el-option
              v-for="item in quarterOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker
            v-model="filters.year"
            format="yyyy" class="w-100"
            value-format="yyyy"
            type="year" @change="filterOkrs"
            placeholder="Chọn năm">
        </el-date-picker>
      </div>
      <HeaderOKRs @getListOkr="getListOkr"/>
    </div>
    <div class="card-body">
      <div class="example mb-10">
        <TableOKRs :data-okrs="dataOkrs" :page="page" @getListOkr="getListOkr"/>
        <div id="paginate" class="edu-paginate mx-auto d-flex justify-content-center">
          <paginate v-model="page" :page-count="lastPage" :page-range="3" :margin-pages="1" :click-handler="changePage"
                    :prev-text="'Trước'" :next-text="'Sau'" :container-class="'pagination b-pagination'" :pageLinkClass="'page-link'"
                    :next-link-class="'next-link-item'" :prev-link-class="'prev-link-item'" :prev-class="'page-link'"
                    :next-class="'page-link'" :page-class="'page-item'">
          </paginate>
        </div>
        <div class="position-absolute mt-3" style="right: 40px;"> Tổng số bản ghi: <b
            style="color: rgb(54, 153, 255);">{{
            total ? total : 0
          }}</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableOKRs from "./component/TableOKRs.vue";
import { GET_LIST_OKR } from "@/core/services/store/okrs/okr.module";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import moment from "moment-timezone";
import {quarterOptions} from "@/common/define";
import { OkrModel } from "@/view/pages/manage-okrs/model/OkrModel";
import HeaderOKRs from "@/view/pages/manage-okrs/component/HeaderOkr.vue";

export default {
  name: 'ManageOkrs',
  components: { HeaderOKRs, TableOKRs },
  data() {
    return {
      loading: false,
      dataOkrs: [],
      total: 0,
      page: 1,
      quarterOptions,
      lastPage: 1,
      filters: {
        name: null,
        quarter: null,
        year: null
      },
      currentQuarter: 1
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Quản lý OKR", name: 'ManageOkrList'},
      {title: "Quản lý nhân sự"}
    ]);
    this.getCurrentQuarter()
    this.getListOkr()
  },
  methods: {
    changePage(obj) {
      this.page = obj
      this.getListOkr();
    },
    filterOkrs() {
      this.page = 1
      this.getListOkr()
    },
    getListOkr() {
      this.loading = true
      const payload = {
        page: this.page,
        name: this.filters.name,
        quarter: this.filters.quarter ?? this.currentQuarter,
        year: this.filters.year ?? Number(moment().format('YYYY'))
      }
      this.$store.dispatch(GET_LIST_OKR, payload).then(res => {
        if (!res.error) {
          const data = res.data
          this.dataOkrs = data.data.map(item => new OkrModel(item)) ?? [];
          this.total = data.total;
          this.page = data.current_page;
          this.lastPage = data.last_page
        }
      }).catch(e => {
        console.log(e)
      }).finally(() => this.loading = false)
    },
    getCurrentQuarter() {
      const month = Number(moment().format('M'));
      this.currentQuarter = Math.ceil(month / 3)
    }
  }
}
</script>

<style scoped>

</style>
